import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const createFacilityGroupMutationAtom = createMutationAtomFactory(
  'settings.facilityGroupCreate',
  (params: {
    name: string;
    facilityIds?: string[];
    defaultFacilityId?: string;
    customAttributes?: Record<string, unknown>;
  }) => ({
    coreFacilityGroupCreate: {
      __args: {
        input: {
          name: params.name,
          facilityIds: params.facilityIds,
          defaultFacilityId: params.defaultFacilityId,
          customAttributes: params.customAttributes,
        },
      },
      id: true,
      name: true,
    },
  }),
);
